
import React from 'react';
import WhatsappConnectionsFeature from '../features/connections/channels/WhatsappConnections';
import WhatsappCoexistenceConnections from '../features/connections/channels/WhatsappCoexistenceConnections';

const ConnectedChannelsPage: React.FC = () => {
    return (
        <div className="space-y-6">
            <WhatsappConnectionsFeature />
            <WhatsappCoexistenceConnections />
        </div>
    );
};

export default ConnectedChannelsPage;
